import useTypedContext from "hooks/useTypedContext";
import { AccountContext } from "views/AccountWrapper";
import { AccessResult, NO_ACCESS_MESSAGE, hasAnyRequiredActionsInAnySpace } from "utils/access";
import { Action } from "types/generated";

export const CONTEXT_CREATE_ACCESS_TYPES = [Action.SpaceAdmin, Action.ContextCreate];

/**
 * Hook that returns whether current user can create contexts
 * User needs to have SpaceAdmin or ContextCreate actions in at least one space
 * @returns {AccessResult} Object indicating if user can create contexts and a message if not
 */
const useCanCreateContext = (): AccessResult => {
  const { viewer } = useTypedContext(AccountContext);

  if (viewer.admin) {
    return { result: true };
  }

  const result = hasAnyRequiredActionsInAnySpace(CONTEXT_CREATE_ACCESS_TYPES, viewer);

  if (result) {
    return { result: true };
  }

  return { result: false, message: NO_ACCESS_MESSAGE };
};

export default useCanCreateContext;
